module.exports = __webpack_public_path__ + "static/media/pandas-fortune.774a336b.gif";